import { useState } from "react";
import { Tokens } from "./EditProfileDialog";
import { useUser } from "./UserProvider";
import { NavBar } from "./Navbar";

export function TokenPage() {
    const {userInfo} = useUser();

    const [token, setToken] = useState(userInfo?.tokens.length > 0 ? userInfo?.tokens[0] : "");
    
    return (
        <div style={{
        }}>
            <NavBar />
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                
                width: "100vw",
                padding: "20px",
            }}>
                <div style={{
                    fontSize: "1.5em",
                    marginBottom: "20px",
                }}>Click to copy your token: </div>
                <Tokens token={token} />
            </div>
        </div>
    )
}